import { render, staticRenderFns } from "./SpecialSaleItem.vue?vue&type=template&id=280d7faa&scoped=true&"
import script from "./SpecialSaleItem.vue?vue&type=script&lang=js&"
export * from "./SpecialSaleItem.vue?vue&type=script&lang=js&"
import style0 from "./SpecialSaleItem.vue?vue&type=style&index=0&id=280d7faa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d7faa",
  null
  
)

export default component.exports